module.exports = __webpack_public_path__ + "media/Text_left_+_sub.5db3c2d8.mp4";